import {Button, Card, Flex, Form, FormProps, Input} from "antd";
import {components} from "../types/OnuoGate";
import apiClient from "../services/ApiClient";
import {useNavigate} from "react-router-dom";
import React from "react";

export default function Login() {
    const navigate = useNavigate();

    const [isLoading, setIsLoading] = React.useState(false);

    const onFinish: FormProps<
        components["schemas"]["LoginRequest"]
    >["onFinish"] = async (values) => {
        console.log("Success:", values);

        setIsLoading(true);

        const response = await apiClient.loginRequest(values).catch((error) => {
            setIsLoading(false);

            return error;
        });

        if (response.status == 200) {
            if (typeof response.data.token === "string") {
                localStorage.setItem("token", response.data.token);
                apiClient.setToken(response.data.token);
            }

            navigate("/orders");
        }
    };

    const onFinishFailed: FormProps<
        components["schemas"]["LoginRequest"]
    >["onFinishFailed"] = (errorInfo) => {
        console.log("Failed:", errorInfo);
    };

    return (
        <div>
            <Flex gap="middle" align="center" vertical>
                <Card variant="borderless" style={{
                    padding: '0 150px',
                }}>
                    <Form
              
                        layout={'horizontal'}
                        name="basic"
                        labelCol={{span: 8}}
                        wrapperCol={{span: 16}}
                        style={{maxWidth: 600}}
                        initialValues={{remember: true}}
                        onFinish={onFinish}
                        onFinishFailed={onFinishFailed}
                        autoComplete="off"
                    >
                        <Form.Item<components["schemas"]["LoginRequest"]>
                            label="Username"
                            name="username"
                            rules={[
                                {required: true, message: "Please input your username!"},
                            ]}
                        >
                            <Input/>
                        </Form.Item>

                        <Form.Item<components["schemas"]["LoginRequest"]>
                            label="Password"
                            name="password"
                            rules={[
                                {required: true, message: "Please input your password!"},
                            ]}
                        >
                            <Input.Password/>
                        </Form.Item>

                        <Form.Item label={null}>
                            <Button loading={isLoading} type="primary" htmlType="submit">
                                Submit
                            </Button>
                        </Form.Item>
                    </Form>
                </Card>
            </Flex>
        </div>
    );
}
